function c2Rocommendations(product_id) {
  const productRecommendationsSection = $('.c2-rocommendations');
  var c2_recommended_product;
  
  fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+product_id+"&limit=10&intent=related")
    .then(response => response.json())
    .then(({ products }) => {
      if (products.length > 0) {
        var prod_counter = 0;
        for (let i = 0; i < products.length; i++) {
        if(!products[i].tags.includes('hide_shopify_recommendation') && prod_counter < 3){
          prod_counter = prod_counter + 1;
          let promotion_tag = 'promotion_10sitewide';
          let discount_percentage = 0;
          
             discount_percentage = 10;
          
            
          let product_price = products[i].price;
          let promotion_discounted_price = product_price;
          let promotion_compare_price = '';
          if(products[i].tags.includes(promotion_tag)){
            if(products[i].price < products[i].compare_at_price){
               product_price = products[i].compare_at_price;
            }
            promotion_discounted = ((product_price / 100) * discount_percentage / 100)
            promotion_discounted_price = ((products[i].price / 100) - promotion_discounted) * 100;
            if(promotion_discounted_price < product_price){
              promotion_compare_price = "$"+(product_price/100).toFixed(2);
              // promotion_discounted_price =  (Math.ceil((promotion_discounted_price/100) * 10) / 10);
              if (Number((promotion_discounted_price/100).toFixed(2).slice(-2)) === 99) {
                    promotion_discounted_price =  (Math.ceil((promotion_discounted_price/100) * 10) / 10);
                }
              else{
                   promotion_discounted_price =  (promotion_discounted_price/100);
              }
            }
            else if(promotion_discounted_price == product_price){
              promotion_discounted_price = product_price/100;
            }
          }
          else{
            promotion_discounted_price = product_price/100;
          }
            
          let product_description = jQuery(products[i].description).text();
          product_description = product_description.substring(0, 80)
  
          if(i == 0 || prod_counter == 1){
            c2_recommended_product = '<h4>YOU MAY ALSO LIKE</h4><div class="c2-rocommendations-product"><div class="c2-rocommendations-product-img"><img src="'+products[i].featured_image+'"/></div><div class="c2-rocommendations-product-info"><a class="is-h6 c2-rocommendations-product-heading" href="'+products[i].url+'">'+products[i].title+'</a><p class="is-text-small c2-rocommendations-product-description">'+product_description+'</p><div class="is-h6 c2-rocommendations-product-price"><span class="money ">$'+promotion_discounted_price.toFixed(2)+'</span><span class="promotion___price compare-at-price">'+promotion_compare_price+'</span></div><a class="c2-rocommendations-product-add-to-cart button--primary" data-id="'+products[i].variants[0].id+'">ADD</a></div></div>'
          }else{
            c2_recommended_product += '<div class="c2-rocommendations-product"><div class="c2-rocommendations-product-img"><img src="'+products[i].featured_image+'"/></div><div class="c2-rocommendations-product-info"><a class="is-h6 c2-rocommendations-product-heading" href="'+products[i].url+'">'+products[i].title+'</a><p class="is-text-small c2-rocommendations-product-description">'+product_description+'</p><div class="is-h6 c2-rocommendations-product-price"><span class="money ">$'+promotion_discounted_price.toFixed(2)+'</span><span class="promotion___price compare-at-price">'+promotion_compare_price+'</span></div><a class="c2-rocommendations-product-add-to-cart button--primary" data-id="'+products[i].variants[0].id+'">ADD</a></div></div>'
          }
        }  
        
      }
      productRecommendationsSection[0].innerHTML = c2_recommended_product;
      productRecommendationsSection[1].innerHTML = c2_recommended_product;
      }
    }
  );
}
